import { createSelector } from 'reselect';

const selectWarehouses = (state: any) => state.warehouses;


export const selectWarehousesCurrentItem = createSelector([selectWarehouses], (warehouses) => warehouses.current);

export const selectWarehousesListItems = createSelector([selectWarehouses], (warehouses) => warehouses.list);

export const selectWarehousesItemById = (itemId: any) =>
    createSelector(selectWarehousesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectWarehousesQueryItems = createSelector([selectWarehouses], (warehouses) => warehouses.query);

export const selectWarehousesCreatedItem = createSelector([selectWarehouses], (warehouses) => warehouses.create);

export const selectWarehousesUpdatedItem = createSelector([selectWarehouses], (warehouses) => warehouses.update);

export const selectWarehousesReadItem = createSelector([selectWarehouses], (warehouses) => warehouses.read);

export const selectWarehousesDeletedItem = createSelector([selectWarehouses], (warehouses) => warehouses.delete);

export const selectWarehousesSearchedItems = createSelector([selectWarehouses], (warehouses) => warehouses.search);

export const selectWarehousesItemsCount = createSelector([selectWarehouses], (warehouses) => warehouses.count);

export const selectWarehousesItemsFilter = createSelector([selectWarehouses], (warehouses) => warehouses.filter);